module.exports = __webpack_public_path__ + "img/algeria.44eaa886.png";